import BaseService from "./base.service";

class MockLogsService extends BaseService {
  get entity() {
    return "mocks-logs";
  }
  clearMockLogs() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`mocks-logs/clear`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
  getInfo(mockLogId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`mocks-logs/${mockLogId}?include=questions`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}
export default new MockLogsService();
